import { render, staticRenderFns } from "./AbsencePage.vue?vue&type=template&id=2c6eba76&scoped=true"
import script from "./AbsencePage.vue?vue&type=script&lang=js"
export * from "./AbsencePage.vue?vue&type=script&lang=js"
import style0 from "./AbsencePage.vue?vue&type=style&index=0&id=2c6eba76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6eba76",
  null
  
)

export default component.exports